import * as interestRateApi from '../api/interestRate';
import { KeyedAsyncCache } from './asyncCache';

const htxRateCache = new KeyedAsyncCache<number | undefined>(
  async (htxId) => {
    const rows = await interestRateApi.listInterestRateOverrides({ scope: 'HTX', targetId: htxId, active: true });
    return rows[0]?.ratePercentPerYear;
  },
  undefined,
  'interestRate:htx',
);

const farmerRateCache = new KeyedAsyncCache<number | undefined>(
  async (farmerId) => {
    const rows = await interestRateApi.listInterestRateOverrides({ scope: 'FARMER', targetId: farmerId, active: true });
    return rows[0]?.ratePercentPerYear;
  },
  undefined,
  'interestRate:farmer',
);

/** The cooperative's own active interest-rate override, if any — undefined
 * means "no override, use the loan's own stored rate" (see resolveEffectiveRatePercent). */
export function getHtxInterestRateOverride(htxId?: string): number | undefined {
  if (!htxId) return undefined;
  return htxRateCache.get(htxId);
}

export function getFarmerInterestRateOverride(farmerId?: string): number | undefined {
  if (!farmerId) return undefined;
  return farmerRateCache.get(farmerId);
}
